import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2019 - 2022</p>
          <h2 className="text-3xl md:text-4xl font-bold">Educational Qualification</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Bachelor degree in Software Engineering"
            subTitle="Matemfen Higher Institute - Yaounde - 2022"
            result="Great"
            des="Continuity of my DUT software engineering program with an additional introduction to delivery concepts and devops tools."
          />
          <ResumeCard
            title="Technical University degree in Software Engineering"
            subTitle="IUT Fotso Victor - Bandjoun - 2021 "
            result="Good"
            des="Learning the application development process, databases, different languages (frontend & backend) and programming layers."
          />
        </div>
      </div>
      {/* part Two */}

      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2022 - 2023</p>
          <h2 className="text-3xl md:text-4xl font-bold">Certificates</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Flutter & Dart - The Complete Guide"
            subTitle="Udemy - (01/03/2023 - 20/05/2023) [2 months]"
            result="Online"
            des="Learnt UI/UX concept and made various project using the skills in this course. Check out my project section for more info !"
          />
          <ResumeCard
            title="Python and Django Full Stack Web"
            subTitle="Udemy - (10/06/2022 - 30/08/2022) [2-3 months]"
            result="Online"
            des="Learnt API and Web concepts and completed various projects using the skills from this course. Check out the project section !"
          />
          <ResumeCard
            title="React The Complete Guide"
            subTitle="Udemy - (01/08/2023 - 24/010/2023) [2 months]"
            result="Online"
            des="Learnt UI/UX concept and made various project using the skills in this course. Check out my project section for more info !"
          />
        </div>
      </div>
    </motion.div>
  );
}

export default Education